// extracted by mini-css-extract-plugin
module.exports = {"container":"duration_container__1e-jv"};